
// Helper hook to safely use the webhook context
export const useSafeWebhook = () => {
  try {
    // Only import the hook if it's available
    const { useWebhook } = require('@/context/WebhookContext');
    if (typeof useWebhook === 'function') {
      try {
        return useWebhook();
      } catch (e) {
        console.log('WebhookContext not available');
        return null;
      }
    }
    return null;
  } catch (e) {
    console.log('WebhookContext module not available');
    return null;
  }
};
